export enum OnyxMapRouteVariant {
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
  ALTERNATIVE = 'alternative',
}
